<template>
  <div
    id="HTML_TEASER_OUTPUT"
    class="html-teaser"
  >
    <slot />
  </div>
</template>
